import loadTechtownBlocks from './techtown'

export default (editor, opts = {}, openBlock) => {
  loadTechtownBlocks(editor, opts, openBlock);
}